// extracted by mini-css-extract-plugin
export default {"wrap":"wrap--ZA_We","content":"content--K2Ynh"};